import * as React from 'react';
import PageTooltip from './PageTooltip'; 
import SearchIcon from "@mui/icons-material/Search";
import {TextField,InputAdornment} from '@mui/material';


const PageInputReduxTooltipCopy = ({ tag, tooltip, value, setValue, width, font="16px" }) =>{
    // set width if not given as prop
    if (width == null){
        width = '500px';
    }
    // set font size if given as prop, else use default
    let style = {}; 
    if (font){
        style['fontSize'] = font;
    }

    return (
      <div className={"d-flex justify-content-center width-fit-content gap-3"}>
        {/* material ui dropdown component */}
        {/* <Typography fontSize={"14px"} className='align-self-center lh-24'>{tag}</Typography> */}
        <PageTooltip title={tooltip}>
          {/* material ui textfield for text input */}
          <TextField
            className='lh-24'
            sx={{ width: width, minWidth: width, backgroundColor: "white"}}
            fontSize={font}
            size="small"
            placeholder={"Search "+tag}   
            value={value} 
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      width: "24px",
                      height: "24px",
                      color: "#54585A",
                    }}
                  />
                </InputAdornment>
              ),
            }}
            onChange={(e) => setValue(e.target.value)}
          />
        </PageTooltip>
      </div>
    );
} 

export default PageInputReduxTooltipCopy;